import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const musicRoutes: RouteObject[] = [
  {
    path: '/music',
    element: lazyElement(() => import('./Main')),
    handle: {
      documentTitle: 'Music',
      crumb: () => ({ label: 'Music', to: '/music' })
    },
  },
];

export default musicRoutes;
